import React from 'react';
import GlobalProps from '../../components/globalProps';

interface Props extends GlobalProps {
  title: string;
}

export function StyleguideSection({ title, children }: Props): JSX.Element {
  return (
    <section className="styleguide__section">
      <header className="styleguide__section-header">
        <h2>{title}</h2>
      </header>
      {children}
    </section>
  );
}
